import type { Handleiding } from './soort';

export const de: Handleiding = {
  code: 'de',
  titel: 'Anleitung',
  inleiding:
    'Ask Gio Tolk dolmetscht ein Gespräch zwischen zwei Menschen, die keine gemeinsame Sprache haben. Hier steht, was jede Schaltfläche tut.',
  knop: 'Anleitung öffnen',
  sluiten: 'Schließen',
  groepGebruik: 'Mitreden',
  groepBeheer: 'Einrichten und verwalten',
  delen: [
    {
      titel: 'Sprechen',
      sleutel: 'praten',
      groep: 'gebruik',
      open: true,
      punten: [
        {
          kop: 'Sprich',
          uitleg:
            'Einmal tippen zum Starten. Die Aufnahme hört von selbst auf, sobald du gut eine Sekunde still bist, oder wenn du noch einmal tippst. Nach einer Minute hört sie in jedem Fall auf.',
        },
        {
          kop: 'Ein Ton nach dem anderen',
          uitleg:
            'Solange die App spricht, kannst du nicht aufnehmen. Und solange du aufnimmst, wartet eine eingehende Übersetzung, bis du fertig bist. Sonst nimmt dein Mikrofon die App auf, und sie hält das für deine Worte.',
        },
        {
          kop: 'Tippe hier deine Nachricht',
          uitleg:
            'Geht neben dem Sprechen und läuft durch dieselbe Übersetzung. Enter schickt ab, Umschalt mit Enter macht eine neue Zeile.',
        },
        {
          kop: 'Zeit zum Verbessern',
          uitleg:
            'Stell ein, wie viele Sekunden du bekommst, um deinen verschrifteten Satz nachzulesen, bevor er weggeht. Auf null geht er sofort.',
        },
        {
          kop: 'Immer selbst prüfen und senden',
          uitleg:
            'Keine Uhr mehr. Jeder Satz wartet, bis du auf Senden drückst. Für alle, die jeden Satz prüfen wollen.',
        },
        {
          kop: 'Übersetzung sofort abspielen',
          uitleg:
            'Ist an. Schalte es aus, wenn du lieber erst liest und selbst bestimmst, wann du zuhörst.',
        },
      ],
    },
    {
      titel: 'Nachrichten lesen',
      sleutel: 'lezen',
      groep: 'gebruik',
      open: true,
      punten: [
        {
          kop: 'Was groß steht',
          uitleg:
            'Was in DEINER Sprache steht, steht groß. Bei deinem eigenen Satz ist das dein Originaltext, damit du prüfen kannst, ob die App dich richtig verstanden hat. Beim anderen ist es die Übersetzung.',
        },
        {
          kop: 'Original oder Übersetzung aufklappen',
          uitleg: 'Die andere Sprache steht darunter, eingeklappt. Tippe auf die Zeile, um sie zu öffnen.',
        },
        {
          kop: 'Das Dreieck',
          uitleg: 'Spielt die Übersetzung noch einmal ab.',
        },
        {
          kop: 'Der sprechende Kopf',
          uitleg:
            'Spielt die eigene Aufnahme des anderen ab. Erscheint nur bei einer GESPROCHENEN Nachricht und nur, wenn „auch deine eigene Stimme mitschicken“ an ist. Bei einer getippten Nachricht gibt es keine Aufnahme.',
        },
      ],
    },
    {
      titel: 'Schaltflächen oben am Bildschirm',
      sleutel: 'knoppen',
      groep: 'gebruik',
      punten: [
        {
          kop: 'Minus und Plus',
          uitleg: 'Macht den Text kleiner oder größer. In fünf Stufen, und es bleibt gespeichert.',
        },
        {
          kop: 'Das Mikrofon',
          uitleg: 'Blendet die Sprechtaste aus, wenn du ohnehin nur tippst. Das spart Platz.',
        },
        {
          kop: 'Die Tastatur',
          uitleg:
            'Blendet das Textfeld aus. Eines von beiden bleibt immer an, sonst könntest du gar nichts mehr sagen.',
        },
      ],
    },
    {
      titel: 'Hereinkommen',
      sleutel: 'binnenkomen',
      groep: 'gebruik',
      punten: [
        {
          kop: 'Welche Sprache sprichst du',
          uitleg:
            'Diese Wahl bestimmt auch die Sprache der Schaltflächen und der Meldungen. Ihr seht also beide einen anderen Bildschirm, und das ist so gewollt.',
        },
        {
          kop: 'Deine Stimme in der Übersetzung',
          uitleg:
            'Wähle, ob du männlich oder weiblich klingst. Das gehört zu DIR, nicht zum Raum: Beide Teilnehmer wählen getrennt.',
        },
        {
          kop: 'Erlaubnis für das Mikrofon',
          uitleg:
            'Der Browser fragt beim Hereinkommen danach. Sagst du nein, kannst du trotzdem tippen. Die Erlaubnis lässt sich später über das Schloss in der Adressleiste nachreichen.',
        },
      ],
    },
    {
      titel: 'Unten, eingeklappt',
      sleutel: 'onderin',
      groep: 'beheer',
      punten: [
        {
          kop: 'Auffangliste für Wörter',
          uitleg:
            'Wörter, die immer gleich übersetzt werden müssen: Namen, Fachbegriffe, Marken. Gilt für den ganzen Raum.',
        },
        {
          kop: 'Einstellungen ändern',
          uitleg:
            'Sprache, Stimme, Ton und Rechtschreibkorrektur lassen sich auch MITTEN im Gespräch umstellen. Was du hier änderst, gilt sofort für euch beide.',
        },
      ],
    },
    {
      titel: 'Ein Gespräch beginnen',
      sleutel: 'beginnen',
      groep: 'beheer',
      punten: [
        {
          kop: 'Name des Gesprächs',
          uitleg:
            'Darf leer bleiben. Er steht nur oben auf deinem Bildschirm, damit du weißt, mit wem du sprichst.',
        },
        {
          kop: 'Sprecher 1 und Sprecher 2',
          uitleg:
            'Die beiden Sprachen dieses Gesprächs. Wer zuerst hereinkommt, bekommt den ersten Platz. Die Sprachen lassen sich später noch umstellen.',
        },
        {
          kop: 'Ton der Übersetzung',
          uitleg:
            'Links wählst du Duzen oder Siezen, rechts die Stimmung: neutral, freundschaftlich, geschäftlich, offiziell oder Partner. Ohne Vorgabe wählt das Modell fast immer die förmliche Form, und die klingt in einem normalen Gespräch distanziert.',
        },
        {
          kop: 'Auch deine eigene Stimme mitschicken',
          uitleg:
            'Der andere hört neben der Übersetzung auch deine eigene Aufnahme. Praktisch, um eine Sprache zu lernen. Schalte das bei einem heiklen Gespräch aus: Wer die Aufnahme bekommt, kann sie behalten.',
        },
        {
          kop: 'Rechtschreibung im eigenen Text korrigieren',
          uitleg:
            'Ist an. Schalte es aus, um zu sehen, was das Modell wirklich verstanden hat. Steht dort dann ein seltsamer Satz, weißt du, ob er falsch verstanden oder richtig verstanden und danach geglättet wurde.',
        },
        {
          kop: 'Mit PIN',
          uitleg:
            'Gib den Code mündlich weiter, nicht in derselben Nachricht wie den Link. Das schützt gegen einen weitergeleiteten Link.',
        },
        {
          kop: 'Der QR-Code',
          uitleg:
            'Lass ihn den anderen scannen oder schick den Link. Ein Raum verfällt nach vier Stunden von selbst.',
        },
      ],
    },
    {
      titel: 'Was mit deinem Gespräch geschieht',
      sleutel: 'privacy',
      groep: 'beheer',
      punten: [
        {
          kop: 'Der Text wird nicht aufbewahrt',
          uitleg:
            'Was ihr sagt, kommt nicht in die Datenbank. Nur wann und wie viel gesprochen wurde, für die Kosten.',
        },
        {
          kop: 'Aufnahmen verschwinden von selbst',
          uitleg: 'Audio bleibt zehn Minuten im Speicher und ist danach weg.',
        },
        {
          kop: 'Der Raum verfällt',
          uitleg: 'Vier Stunden nach dem Anlegen. Danach funktioniert der Link nicht mehr.',
        },
        {
          kop: 'Es gibt ein Budget',
          uitleg:
            'Pro Raum und pro Monat. Ist es aufgebraucht, hört die App mit dem Übersetzen auf und sagt das. Das ist keine Störung.',
        },
      ],
    },
  ],
};
